import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery } from '@tanstack/react-query';
import { TeamQuarterlyBonusResultResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  year: number;
  quarter: number;
};

const getTeamQuarterlyBonusResults = async (
  params: Params
): Promise<TeamQuarterlyBonusResultResponse> => {
  const { data } = await api.get<TeamQuarterlyBonusResultResponse>(
    `${BI_BASE_URL}/managers/team/quarterly/bonus/results`,
    {
      params,
    }
  );
  return data ?? [];
};

export const useGetTeamQuarterlyBonusResults = ({ year, quarter }: Params) => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.TEAM_QUARTERLY_BONUS_RESULTS, year, quarter],
    queryFn: () => getTeamQuarterlyBonusResults({ year, quarter }),
  });
};
